import {
  AppealsTimeIcon,
  BooksIcon,
  CheckmarkCircleIcon,
  DocumentBadgeCheckIcon,
  DocumentBadgeExclamationIcon,
  ShareIcon,
} from "@repo/edtech-assets";

import type { Assets } from "./types";

export const DEFAULT_ASSETS: Assets = {
  confirmCodeModalSuccessIcon: CheckmarkCircleIcon,
  openQuestionAttachFileIcon: ShareIcon,
  mainTestCoverNotStartedIcon: BooksIcon,
  mainTestCoverInProgressIcon: AppealsTimeIcon,
  mainTestCoverQueuedIcon: DocumentBadgeCheckIcon,
  checkTestCoverIcon: DocumentBadgeExclamationIcon,
};